// utils/get-icon-from-type.ts (or wherever it lives)
import { isClinicStore, isVendingMachine, isCataract } from './define-store-types';
import markerClinicIcon from '../../assets/images/map-markers/clinic.png';
import markerOpticsIcon from '../../assets/images/map-markers/optic.png';
import markerVendingIcon from '../../assets/images/map-markers/vending.png';
import cataractIcon from '../../assets/images/map-markers/cataract.png';
import {
  MARKER_WIDTH,
  MARKER_HEIGHT,
  MARKER_WIDTH_ACTIVE,
  MARKER_HEIGHT_ACTIVE,
} from '../../constants/ecp-locator';

interface MarkerIcon {
  type: string,
  surgery?: string | null,
  code?: string,
  codeToCheck?: string,
}

export const getMarkerIcon = ({
  type, code, codeToCheck, surgery,
}: MarkerIcon) => {
  const isActive = codeToCheck === code;
  let url: string;

  switch (true) {
    case isCataract(surgery):
      url = cataractIcon;
      break;
    case isClinicStore(type):
      url = markerClinicIcon;
      break;
    case isVendingMachine(type):
      url = markerVendingIcon;
      break;
    default:
      url = markerOpticsIcon;
      break;
  }

  const width  = isActive ? MARKER_WIDTH_ACTIVE  : MARKER_WIDTH;
  const height = isActive ? MARKER_HEIGHT_ACTIVE : MARKER_HEIGHT;

  return { url, width, height };
};
